// React imports
import React, { useEffect, useState } from "react";

// Material-UI imports
import { makeStyles } from "@material-ui/core/styles";
import styles from "assets/jss/material-dashboard-pro-react/views/dashboardStyle.js";

// Component imports
import CreatePodcastModal from "views/Components/CreatePodastModal";
import CreateLabModal from "views/Components/CreateLabModal";
import CreateWritingModal from "views/Components/CreateWritingModal.js";
import CreateCaseStudyModal from "../CaseStudy/CreateCaseStudyModal";
import CreateModelDevelopmentProjectModal from "../Model Development/CreateModelDevelopmentProjectModal";
import CreateModelValidationProjectModal from "../Model Validation/CreateModelValidationProjectModal";
import CreateProjectModal from "../ProjectsDashboard/CreateProjectModal";
import CreateCourseModal from "../../Components/CreateCourseModal";
import CreateFormModal from "../../Components/CreateFormModal";

// Model imports
import PodcastDetails from "../Models/PodcastDetails";
import LabDetails from "../Models/LabDetails";
import WritingModel from "../Models/WritingModel";
import CourseDetails from "../Models/CourseDetails";
import ModelDevelopmentProjectDetails from "../Models/ModelDevelopmentProjectDetails";
import ModelValidationProjectDetails from "../Models/ModelValidationProjectDetails";
import ProjectDetails from "../Models/ProjectDetails";
import CaseStudyDetails from "../Models/CaseStudyDetails";
import FormDetails from "../Models/FormDetails";

// API imports
import { 
  createPodcastAPI,
  createLabAPI,
  fetchWritingTemplatesAPI,
  createWritingAPI,
  addArtifactToCourse,
  createCourseAPI,
  createJSONProjectAPI
} from "views/APIs/APIUtility";
import { createCaseStudyAPI } from "views/APIs/CaseStudyUtility";
import { 
  createModelDevelopmentProjectAPI,
  createModelValidationProjectAPI
} from "../../APIs/ToolboxUtility";
import { 
  importArtifactToProjectAPI,
  createProjectAPI
} from "views/APIs/ProjectsUtility";

// Utility imports
import { fetchImageAsFile } from "views/Dashboard/Course/CourseConstants";
import { image_name, identifiers } from "../Constants";

// Context imports
import NotificationContext from "views/Components/Context.js";


const useStyles = makeStyles(styles);

export const AllModalLauncher = ({
  projectId,
  isCourse = false,
  toolboxType,
  name = "",
  description = "",
  setTitleDescriptionForStep,
  openModal,
  setOpenModal,
}) => {
  const classes = useStyles();
  const podcastImages = require.context("assets/img", true);
  const images = require.context("assets/img/create_cards_16_9/", true);
  const { showNotification } = React.useContext(NotificationContext);

  const [newPodcastDetails, setNewPodcastDetails] = React.useState(
    new PodcastDetails(name, description)
  );
  const [newLabDetails, setNewLabDetails] = React.useState(
    new LabDetails(name, description)
  );
  const [newWritingDetails, setNewWritingDetails] = React.useState(
    new WritingModel(name, description)
  );
  const [newCaseStudy, setNewCaseStudy] = React.useState(
    new CaseStudyDetails(name, description)
  );
  const [
    newModelDevelopmentProjectDetails,
    setNewModelDevelopmentProjectDetails,
  ] = React.useState(new ModelDevelopmentProjectDetails(name, description));
  const [
    newModelValidationProjectDetails,
    setNewModelValidationProjectDetails,
  ] = React.useState(new ModelValidationProjectDetails(name, description));
  const [newProjectDetails, setNewProjectDetails] = React.useState(
    new ProjectDetails(name, description)
  );
  const [newCourseDetails, setNewCourseDetails] = React.useState(
    new CourseDetails(
      name,
      description,
      "# Instructions\n - Course Name: {{name}} \n - Course Description: {{description}} \n- Number of modules: 5\n- Course requirements: Create an engaging and comprehensive course outline that contains the above specified number of modules.\n- Module structure:\n  - Description: Provide a brief summary of each module that encapsulates the main topics and key takeaways.\n  - Learning objectives: Include a list of specific, actionable objectives for each module. Clearly outline what learners will gain or accomplish by completing the module.\n- Objective focus: Ensure that learning objectives are concise, measurable, and relevant to the overall course content.",
      [],
      ""
    )
  );
  const [newFormDetails, setNewFormDetails] = React.useState(
    new FormDetails(name, description)
  );

  const onLaunch = (toolboxType, id) => {
    switch (toolboxType) {
      case "PODCAST":
        // /podcastdesign/podcast/
        window.open(`/create/podcastdesign/podcast/${id}`, "_blank");
        break;
      case "COURSE":
        // /course-design/courses/:courseID/
        window.open(`/create/course-design/courses/${id}`, "_blank");
        break;
      case "CONCEPT_LABS":
        // /labdesign/lab/:labID
        window.open(`/create/labdesign/lab/${id}`, "_blank");
        break;
      case "CASE_STUDY":
        // /case_study/:caseStudyID
        window.open(`/create/case_study/${id}`, "_blank");
        break;
      case "HANDOUT":
        // /handout/:writingId
        window.open(`/create/handout/${id}`, "_blank");
        break;
      case "RESEARCH_REPORT":
        // /research_report/:writingId
        window.open(`/create/research_report/${id}`, "_blank");
        break;
      case "KEY_INSIGHTS":
        // /key_insights/:writingId
        window.open(`/create/key_insights/${id}`, "_blank");
        break;
      case "BLOG":
        // /blog/:writingId
        window.open(`/create/blog/${id}`, "_blank");
        break;
      case "WHITEPAPER":
        // /white_paper/:writingId
        window.open(`/create/white_paper/${id}`, "_blank");
        break;
      case "PROJECT_PLAN":
        // /project_plan/:writingID
        window.open(`/create/project_plan/${id}`, "_blank");
        break;
      case "NEWSLETTER":
        // /news_letter/:writingID
        window.open(`/create/news_letter/${id}`, "_blank");
        break;
      case "MODEL_DEVELOPMENT":
        // /model_development/model/:projectId
        window.open(`/create/model_development/model/${id}`, "_blank");
        break;
      case "MODEL_VALIDATION":
        // /model_validation/model/:projectId
        window.open(`/create/model_validation/model/${id}`, "_blank");
        break;
      case "PROJECT":
        // /project-design/projects/:projectID
        window.open(`/create/project-design/projects/${id}`, "_blank");
        break;
      case "FORM":
        // /form-design/:formId
        window.open(`/create/form-design/${id}`, "_blank");
        break;
      case "SESSION":
        // /sessions/session/:sessionId
        window.open(`/create/sessions/session/${id}`, "_blank");
        break;
      default:
        return;
    }
  };

  const [iconImage, setIconImage] = React.useState();

  const [createPodcastModal, setCreatePodcastModal] = React.useState(false);
  const [createLabModal, setCreateLabModal] = React.useState(false);
  const [createWritingModal, setCreateWritingModal] = React.useState(false);
  const [createCaseStudyModal, setCreateCaseStudyModal] = React.useState(false);
  const [
    createModelDevelopmentModal,
    setCreateModelDevelopmentModal,
  ] = React.useState(false);
  const [
    createModelValidationModal,
    setCreateModelValidationModal,
  ] = React.useState(false);
  const [createProjectModal, setCreateProjectModal] = React.useState(false);
  const [createCourseModal, setCreateCourseModal] = React.useState(false);
  const [createFormModal, setCreateFormModal] = React.useState(false);

  const [writingId, setWritingId] = React.useState("");
  const [identifier, setIdentifier] = React.useState("research_report");
  const [identifierPrint, setIdentifierPrint] = React.useState(
    identifiers["research_report"]
  );

  useEffect(() => {
    switch (toolboxType) {
      case "PODCAST":
        setCreatePodcastModal(openModal);
        break;
      case "CONCEPT_LABS":
        setCreateLabModal(openModal);
        break;
      case "RESEARCH_REPORT":
      case "WHITE_PAPER":
      case "BLOG":
      case "NEWS_LETTER":
      case "HANDOUT":
      case "KEY_INSIGHTS":
      case "PROJECT_PLAN":
        setIdentifier(toolboxType.toLowerCase());
        setIdentifierPrint(identifiers[toolboxType.toLowerCase()]);
        setCreateWritingModal(openModal);
        break;
      case "CASE_STUDY":
        setCreateCaseStudyModal(openModal);
        break;
      case "MODEL_DEVELOPMENT":
        setCreateModelDevelopmentModal(openModal);
        break;
      case "MODEL_VALIDATION":
        setCreateModelValidationModal(openModal);
        break;
      case "PROJECT":
        setCreateProjectModal(openModal);
        break;
      case "COURSE":
        setCreateCourseModal(openModal);
        break;
      case "FORM":
        setCreateFormModal(openModal);
        break;
      case "SESSION":
        // Session doesn't have a modal yet, just close the modal
        setAssetModal(false);
        break;
      default:
        break;
    }
  }, [toolboxType, openModal]);

  const [assetModal, setAssetModal] = useState(false);

  const [loader, setLoader] = React.useState({
    isLoading: false,
    message: "",
  });

  const [currentDialog, setCurrentDialog] = React.useState("Create Writing");

  const handleIconUpload = (event) => {
    const file = event.target.files[0];
    if (file) {
      setIconImage(file);
    }
  };

  useEffect(() => {
    if (
      !createPodcastModal &&
      !createLabModal &&
      !createWritingModal &&
      !createCaseStudyModal &&
      !createModelDevelopmentModal &&
      !createModelValidationModal &&
      !createProjectModal &&
      !createCourseModal &&
      !createFormModal
    ) {
      setOpenModal(false);
    }
  }, [
    createPodcastModal,
    createLabModal,
    createWritingModal,
    createCaseStudyModal,
    createModelDevelopmentModal,
    createModelValidationModal,
    createProjectModal,
    createCourseModal,
    createFormModal,
  ]);

  const handleAssetModalClose = () => {
    // Close the main modal
    setAssetModal(false);

    //Initialize the sub modals to false
    setCreatePodcastModal(false);
    setCreateLabModal(false);
    setCreateWritingModal(false);

    //Miscealenous
    setLoader({ isLoading: false, message: "" });
    setCurrentDialog("Create Writing");
    setIconImage(null);

    // Reset objects
    setNewPodcastDetails(new PodcastDetails());
    setNewLabDetails(new LabDetails());
    setNewWritingDetails(new WritingModel());
  };

  const handleCreatePodcast = async (modulesAtCreation = true) => {
    setLoader({ isLoading: true, message: "Creating Podcast..." });
    const imageToUse =
      iconImage || (await fetchImageAsFile(podcastImages("./podcast.png")));
    const formData = new FormData();
    formData.append("podcast_name", newPodcastDetails.name);
    formData.append("podcast_description", newPodcastDetails.description);
    formData.append("podcast_image", imageToUse);
    formData.append("podcast_transcript", newPodcastDetails.podcastOutline);
    newPodcastDetails.uploadedFiles.forEach((file) => {
      formData.append("files", file);
    });

    try {
      const data = await createPodcastAPI(formData);
      // import artifact to project
      if (isCourse) {
        // await handleImportArtifact(projectId, data._id, "Podcast");
      } else {
        const importFormData = new FormData();
        importFormData.append("artifact_id", data._id);
        importFormData.append("artifact_type", "PODCAST");
        importFormData.append("artifact_name", data.podcast_name);
        importFormData.append("artifact_description", data.podcast_description);
        importFormData.append("project_id", projectId);

        await importArtifactToProjectAPI(importFormData);
        setTitleDescriptionForStep(
          data.podcast_name,
          data.podcast_description,
          data._id
        );
      }
      showNotification("Podcast created successfully", "success");
      setNewPodcastDetails(new PodcastDetails());
      onLaunch("PODCAST", data._id);
    } catch (error) {
      showNotification(error, "danger");
    } finally {
      setLoader({ isLoading: false, message: "" });
      handleAssetModalClose();
    }
  };

  const handleCreateLab = async () => {
    // setLoading({ loading: true, message: "Creating Lab..." });
    const formData = new FormData();
    formData.append("lab_name", newLabDetails.name);
    formData.append("lab_description", newLabDetails.description);
    formData.append("lab_outline", newLabDetails.labOutline);
    newLabDetails.uploadedFiles.forEach((file) => {
      formData.append("files", file);
    });
    formData.append(
      "lab_image",
      iconImage || (await fetchImageAsFile(images("./labs.png")))
    );

    try {
      const data = await createLabAPI(formData);
      if (isCourse) {
        // await handleImportArtifact(projectId, data._id, "Lab");
      } else {
        const importFormData = new FormData();
        importFormData.append("artifact_id", data._id);
        importFormData.append("artifact_type", "CONCEPT_LABS");
        importFormData.append("artifact_name", data.lab_name);
        importFormData.append("artifact_description", data.lab_description);
        importFormData.append("project_id", projectId);
        await importArtifactToProjectAPI(importFormData);
        setTitleDescriptionForStep(
          data.lab_name,
          data.lab_description,
          data._id
        );
      }
      setNewLabDetails(new LabDetails());
      showNotification("Lab created successfully", "success");
      onLaunch("CONCEPT_LABS", data._id);
    } catch (error) {
      showNotification(error, "danger");
    } finally {
      setLoader({ isLoading: false, message: "" });
      handleAssetModalClose();
    }
  };

  //   Writings
  const handleGenerateTemplate = async (prompt, use_metaprompt) => {
    try {
      setLoader({
        isLoading: true,
        message: `Let's create some templates for the ${identifierPrint}...`,
      });
      const formData = new FormData();
      formData.append("identifier", identifier);
      newWritingDetails.uploadedFiles.forEach((file) => {
        formData.append("files", file);
      });
      formData.append("target_audience", newWritingDetails.target_audience);
      formData.append("expected_length", newWritingDetails.expected_length);
      formData.append("tone", newWritingDetails.tone);

      formData.append("prompt", prompt);
      formData.append("use_metaprompt", use_metaprompt);
      const data = await fetchWritingTemplatesAPI(formData);
      const formattedTemplates = (data.templates || []).map((item) => ({
        template_name: (item.template_name || "Unnamed")
          .replace(/\s*template\s*$/i, "")
          .trim(),
        template_content: item.template_content || "No content available",
      }));

      // Update state with the new template data
      setNewWritingDetails((prevState) => ({
        ...prevState,
        template: formattedTemplates,
      }));
    } catch (error) {
      showNotification(error, "danger");
    } finally {
      setLoader({ isLoading: false, message: "" });
    }
  };

  const handleImportArtifact = async (courseID, artifact_id, artifact_type) => {
    try {
      const formData = new FormData();
      formData.append("course_id", courseID);
      formData.append("artifact_id", artifact_id);
      formData.append("artifact_type", artifact_type);
      await addArtifactToCourse(formData);
    } catch (error) {
      return error;
    }
  };

  const handleCreateWriting = async () => {
    try {
      // Fetch image
      const imageToUse =
        iconImage ||
        (await fetchImageAsFile(images(image_name[identifier.toLowerCase()])));

      // Prepare form data
      const formData = new FormData();
      formData.append("writing_id", writingId);
      formData.append("writing_name", newWritingDetails.name);
      formData.append("writing_description", newWritingDetails.description);
      formData.append("writing_image", imageToUse);
      formData.append("writing_outline", newWritingDetails.outline);
      formData.append("identifier", identifier);

      // Append additional files
      newWritingDetails.uploadedFiles.forEach((file) => {
        formData.append("files", file);
      });

      const data = await createWritingAPI(formData);
      if (isCourse) {
        await handleImportArtifact(projectId, data._id, "Writing");
      } else {
        const importFormData = new FormData();
        importFormData.append("artifact_id", data._id);
        importFormData.append("artifact_type", identifier.toUpperCase());
        importFormData.append("artifact_name", data.writing_name);
        importFormData.append("artifact_description", data.writing_description);
        importFormData.append("project_id", projectId);
        await importArtifactToProjectAPI(importFormData);
        setTitleDescriptionForStep(
          data.writing_name,
          data.writing_description,
          data._id
        );
        setNewWritingDetails(new WritingModel());
      }
      showNotification(identifierPrint + " created successfully", "success");
      onLaunch(identifier.toUpperCase(), data._id);
    } catch (error) {
      console.error("Error occurred:", error);
      showNotification(error, "danger");
    } finally {
      handleAssetModalClose();
    }
  };

  // case study
  const clearCaseStudyModal = () => {
    setNewCaseStudy(new CaseStudyDetails());
    setIconImage(null);
  };

  const handleCreateCaseStudyModalClose = () => {
    setCreateCaseStudyModal(false);
    // setModal(false);
    clearCaseStudyModal();
  };

  const handleCreateCaseStudy = async () => {
    const formData = new FormData();
    formData.append("name", newCaseStudy.name);
    formData.append("description", newCaseStudy.description);

    try {
      const data = await createCaseStudyAPI(formData);
      if (isCourse) {
        await handleImportArtifact(projectId, data._id, "CaseStudy");
      } else {
        const importFormData = new FormData();
        importFormData.append("artifact_id", data._id);
        importFormData.append("artifact_type", "CASE_STUDY");
        importFormData.append("artifact_name", data.name);
        importFormData.append("artifact_description", data.description);
        importFormData.append("project_id", projectId);
        await importArtifactToProjectAPI(importFormData);
        setTitleDescriptionForStep(data.name, data.description, data._id);
      }
      setNewCaseStudy(new CaseStudyDetails());
      showNotification("Case Study created successfully", "success");
      onLaunch("CASE_STUDY", data._id);
    } catch (error) {
      showNotification(error, "danger");
    } finally {
      handleCreateCaseStudyModalClose();
    }
  };

  // model development
  const handleCreateModelDevelopmentModalClose = () => {
    setCreateModelDevelopmentModal(false);
    setNewModelDevelopmentProjectDetails({
      name: "",
      description: "",
    });
  };

  const handleCreateModelDevelopmentProject = async () => {
    const formData = new FormData();
    formData.append("title", newModelDevelopmentProjectDetails.name);
    formData.append(
      "description",
      newModelDevelopmentProjectDetails.description
    );

    try {
      const data = await createModelDevelopmentProjectAPI(formData);
      if (isCourse) {
        await handleImportArtifact(
          projectId,
          data._id,
          "ModelDevelopmentProject"
        );
      } else {
        const importFormData = new FormData();
        importFormData.append("artifact_id", data._id);
        importFormData.append("artifact_type", "MODEL_DEVELOPMENT");
        importFormData.append("artifact_name", data.title);
        importFormData.append("artifact_description", data.description);
        importFormData.append("project_id", projectId);

        await importArtifactToProjectAPI(importFormData);
        setTitleDescriptionForStep(data.title, data.description, data._id);
      }
      showNotification(
        "Model Development Project created successfully",
        "success"
      );
      setNewModelDevelopmentProjectDetails({
        name: "",
        description: "",
      });
      onLaunch("MODEL_DEVELOPMENT", data._id);
    } catch (error) {
      showNotification(error, "danger");
    } finally {
      handleCreateModelDevelopmentModalClose();
    }
  };

  // model validation
  const handleCreateModelValidationModalClose = () => {
    setCreateModelValidationModal(false);
    setNewModelValidationProjectDetails({
      name: "",
      description: "",
    });
  };

  const handleCreateModelValidationProject = async () => {
    setLoader({
      isLoading: true,
      message: "Creating Model Validation Project...",
    });

    try {
      // Prepare form data
      const formData = new FormData();
      formData.append("title", newModelValidationProjectDetails.name);
      formData.append(
        "description",
        newModelValidationProjectDetails.description
      );

      // Create project via API call
      const data = await createModelValidationProjectAPI(formData);
      if (isCourse) {
        await handleImportArtifact(
          projectId,
          data._id,
          "ModelValidationProject"
        );
      } else {
        const importFormData = new FormData();
        importFormData.append("artifact_id", data._id);
        importFormData.append("artifact_type", "MODEL_VALIDATION");
        importFormData.append("artifact_name", data.title);
        importFormData.append("artifact_description", data.description);
        importFormData.append("project_id", projectId);
        await importArtifactToProjectAPI(importFormData);
        setTitleDescriptionForStep(data.title, data.description, data._id);
        setNewModelValidationProjectDetails({
          name: "",
          description: "",
        });
      }
      showNotification("Project created successfully", "success");
      onLaunch("MODEL_VALIDATION", data._id);
    } catch (error) {
      showNotification(
        `Failed to create project: ${error.message || error}`,
        "danger"
      );
    } finally {
      setLoader({ isLoading: false, message: "" });
      handleCreateModelValidationModalClose();
    }
  };

  // project
  const handleCreateProjectModalClose = () => {
    setCreateProjectModal(false);
    setNewProjectDetails({
      name: "",
      description: "",
    });
  };

  const handleCreateProject = async () => {
    setLoader({ isLoading: true, message: "Creating Project..." });
    try {
      // Prepare form data
      const formData = new FormData();
      formData.append("project_name", newProjectDetails.name);
      formData.append("project_description", newProjectDetails.description);

      // Create project via API call
      const data = await createProjectAPI(formData);

      showNotification("Project created successfully", "success");
      setNewProjectDetails({
        name: "",
        description: "",
      });
      onLaunch("PROJECT", data._id);
    } catch (error) {
      showNotification(
        `Failed to create project: ${error.message || error}`,
        "danger"
      );
    } finally {
      setLoader({ isLoading: false, message: "" });
      handleCreateProjectModalClose();
    }
  };

  // course
  const handleCreateCourseModalClose = () => {
    setCreateCourseModal(false);
    setNewCourseDetails({
      name: "",
      description: "",
      template:
        "# Instructions\n - Course Name: {{name}} \n - Course Description: {{description}} \n- Number of modules: 5\n- Course requirements: Create an engaging and comprehensive course outline that contains the above specified number of modules.\n- Module structure:\n  - Description: Provide a brief summary of each module that encapsulates the main topics and key takeaways.\n  - Learning objectives: Include a list of specific, actionable objectives for each module. Clearly outline what learners will gain or accomplish by completing the module.\n- Objective focus: Ensure that learning objectives are concise, measurable, and relevant to the overall course content.",
      uploadedFiles: [],
      courseOutline: "",
    });
  };

  const handleCreateCourse = async (modulesAtCreation = true) => {
    setLoader({ isLoading: true, message: "Creating Course..." });
    try {
      // Prepare form data
      const formData = new FormData();
      formData.append("course_name", newCourseDetails.name);
      formData.append("course_description", newCourseDetails.description);
      formData.append("course_template", newCourseDetails.template);
      formData.append("course_outline", newCourseDetails.courseOutline);
      if (!modulesAtCreation) {
        formData.append("course_outline", "");
        formData.append("modulesAtCreation", modulesAtCreation);
      } else {
        formData.append("course_outline", newCourseDetails.courseOutline);
      }

      // Create course via API call
      const data = await createCourseAPI(formData);

      if (isCourse) {
        await handleImportArtifact(projectId, data._id, "Course");
      } else {
        const importFormData = new FormData();
        importFormData.append("artifact_id", data._id);
        importFormData.append("artifact_type", "COURSE");
        importFormData.append("artifact_name", data.course_name);
        importFormData.append("artifact_description", data.course_description);
        importFormData.append("project_id", projectId);
        await importArtifactToProjectAPI(importFormData);
        setTitleDescriptionForStep(
          data.course_name,
          data.course_description,
          data._id
        );
      }

      showNotification("Course created successfully", "success");
      setNewCourseDetails({
        name: "",
        description: "",
        template:
          "# Instructions\n - Course Name: {{name}} \n - Course Description: {{description}} \n- Number of modules: 5\n- Course requirements: Create an engaging and comprehensive course outline that contains the above specified number of modules.\n- Module structure:\n  - Description: Provide a brief summary of each module that encapsulates the main topics and key takeaways.\n  - Learning objectives: Include a list of specific, actionable objectives for each module. Clearly outline what learners will gain or accomplish by completing the module.\n- Objective focus: Ensure that learning objectives are concise, measurable, and relevant to the overall course content.",
        uploadedFiles: [],
        courseOutline: "",
      });
      onLaunch("COURSE", data._id);
    } catch (error) {
      showNotification(
        `Failed to create course: ${error.message || error}`,
        "danger"
      );
    } finally {
      setLoader({ isLoading: false, message: "" });
      handleCreateCourseModalClose();
    }
  };

  // form
  const handleCreateFormModalClose = () => {
    setCreateFormModal(false);
    setNewFormDetails({
      name: "",
      description: "",
    });
  };

  const handleCreateForm = async () => {
    setLoader({ isLoading: true, message: "Creating Form..." });
    try {
      // Prepare form data
      const formData = new FormData();
      formData.append("name", newFormDetails.name);
      formData.append("description", newFormDetails.description);

      // Create form via API call
      const data = await createJSONProjectAPI(formData);
      if (isCourse) {
        await handleImportArtifact(projectId, data._id, "Form");
      } else {
        const importFormData = new FormData();
        importFormData.append("artifact_id", data._id);
        importFormData.append("artifact_type", "FORM");
        importFormData.append("artifact_name", data.name);
        importFormData.append("artifact_description", data.description);
        importFormData.append("project_id", projectId);
        await importArtifactToProjectAPI(importFormData);
        setTitleDescriptionForStep(data.name, data.description, data._id);
      }

      showNotification("Form created successfully", "success");

      setNewFormDetails({
        name: "",
        description: "",
      });
      onLaunch("FORM", data._id);
    } catch (error) {
      showNotification(
        `Failed to create form: ${error.message || error}`,
        "danger"
      );
    } finally {
      setLoader({ isLoading: false, message: "" });
      handleCreateFormModalClose();
    }
  };

  return (
    <>
      {/* Podcast Modal */}
      <div>
        <CreatePodcastModal
          newPodcastDetails={newPodcastDetails}
          setNewPodcastDetails={setNewPodcastDetails}
          iconImage={iconImage}
          createPodcastModal={createPodcastModal}
          handleCreatePodcastModalClose={handleAssetModalClose}
          handleCreatePodcast={handleCreatePodcast}
          handleIconUpload={handleIconUpload}
          podcastCreationLoader={loader}
        />
      </div>

      {/* Lab Modal */}
      <div>
        <CreateLabModal
          newLabDetails={newLabDetails}
          setNewLabDetails={setNewLabDetails}
          createLabModal={createLabModal}
          handleCreateLabModalClose={handleAssetModalClose}
          handleCreateLab={handleCreateLab}
        />
      </div>

      {/* Writing Modal */}
      <div>
        <CreateWritingModal
          identifier={identifier}
          identifierPrint={identifierPrint}
          newWritingDetails={newWritingDetails}
          setNewWritingDetails={setNewWritingDetails}
          writingId={writingId}
          setWritingId={setWritingId}
          createWritingModal={createWritingModal}
          handleCreateWritingModalClose={handleAssetModalClose}
          handleCreateWriting={handleCreateWriting}
          handleIconUpload={handleIconUpload}
          iconImage={iconImage}
          writingCreationLoader={loader}
          setWritingCreationLoader={setLoader}
          currentDialog={currentDialog}
          setCurrentDialog={setCurrentDialog}
          handleGenerateTemplate={handleGenerateTemplate}
        />
      </div>

      {/* Case Study Modal */}
      <div>
        <CreateCaseStudyModal
          newCaseStudy={newCaseStudy}
          setNewCaseStudy={setNewCaseStudy}
          createModal={createCaseStudyModal}
          handleCreateModalClose={handleCreateCaseStudyModalClose}
          handleCreateCaseStudy={handleCreateCaseStudy}
        />
      </div>

      {/* Model Development Modal */}
      <div>
        <CreateModelDevelopmentProjectModal
          newProjectDetails={newModelDevelopmentProjectDetails}
          setNewProjectDetails={setNewModelDevelopmentProjectDetails}
          createProjectModal={createModelDevelopmentModal}
          handleCreateProjectModalClose={handleCreateModelDevelopmentModalClose}
          handleCreateProject={handleCreateModelDevelopmentProject}
        />
      </div>

      {/* Model Validation Modal */}
      <div>
        <CreateModelValidationProjectModal
          newProjectDetails={newModelValidationProjectDetails}
          setNewProjectDetails={setNewModelValidationProjectDetails}
          createProjectModal={createModelValidationModal}
          handleCreateProjectModalClose={handleCreateModelValidationModalClose}
          handleCreateProject={handleCreateModelValidationProject}
          projectCreationLoader={loader.isLoading}
        />
      </div>

      {/* Project Modal */}
      <div>
        <CreateProjectModal
          newProjectDetails={newProjectDetails}
          setNewProjectDetails={setNewProjectDetails}
          createProjectModal={createProjectModal}
          handleCreateProjectModalClose={handleCreateProjectModalClose}
          handleCreateProject={handleCreateProject}
          projectCreationLoader={loader}
        />
      </div>

      {/* Course Modal */}
      <div>
        <CreateCourseModal
          newCourseDetails={newCourseDetails}
          setNewCourseDetails={setNewCourseDetails}
          iconImage={iconImage}
          createCourseModal={createCourseModal}
          handleCreateCourseModalClose={handleCreateCourseModalClose}
          handleCreateCourse={handleCreateCourse}
          handleIconUpload={handleIconUpload}
          courseCreationLoader={loader.isLoading}
        />
      </div>

      {/* Form Modal */}
      <div>
        <CreateFormModal
          newFormDetails={newFormDetails}
          setNewFormDetails={setNewFormDetails}
          createFormModal={createFormModal}
          handleCreateFormModalClose={handleCreateFormModalClose}
          handleCreateForm={handleCreateForm}
        />
      </div>
    </>
  );
};
